export default "__VITE_ASSET__095fff39__"